<template>
  <div class="container-fluid">
    <mdb-container>
      <mdb-row>
        <mdb-card-title>
          <strong> Add or Remove Locations</strong>
        </mdb-card-title>
      </mdb-row>

      <mdb-row>
        <LocationsConfig />
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import LocationsConfig from "@/components/LocationsConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "AssetStates",
  components: {
    LocationsConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
